
export default {
    
    adicionarErroDeValidacao(atributoEmValidacao, message){
        atributoEmValidacao.valid = false;
        atributoEmValidacao.message = message;
    },

    validarCampoObrigatorio(valor, atributoEmValidacao) {
        if (this.verificarValorVazio(valor)) {
            this.adicionarErroDeValidacao(atributoEmValidacao, "Campo obrigatório");
        }
     },

     validarCampo(valor, atributoEmValidacao, mensagem) {
        if (this.verificarValorVazio(valor)) {
            this.adicionarErroDeValidacao(atributoEmValidacao, mensagem);
        }
     },

    limparErroDeValidacao(atributoEmValidacao){
        atributoEmValidacao.valid = true;
        if(atributoEmValidacao.message != undefined){
            atributoEmValidacao.message = '';
        }
    },

    validarCamposObrigatorios(valor, validations){
        this.limparValidacao(validations);
        
        for (const attribute in validations) {
            if(valor.hasOwnProperty(attribute)){
                this.validarCampoObrigatorio(valor[attribute], validations[attribute], "Campo obrigatório");
            }
         }
    },

    limparValidacao(validations){
        for (const attribute in validations) {
            this.limparErroDeValidacao(validations[attribute]);
         }
    },

    validadacaoContemErros(validations){
        for (const attribute in validations) {
            if(!validations[attribute].valid){
                return true;
            }
         }
         return false;
    },

    exibirErro(error) {
        if (error.response != null && error.response.data != null) {
            this.$store.commit("setMessages", {message: 'Erro!', variant: 'danger', errors: [error.response.data]});
        } else {
            this.$store.commit("setMessages", {message: 'Erro!', variant: 'danger', errors: [error]});
        }
        window.scrollTo(0, 0);
    },

    
    verificarValorVazio(valor) {
        return null == valor || undefined == valor || valor.toString().trim() === "";
    },

}
